import React from "react";

import {
  Route,
  Redirect,
  Link,
} from "react-router-dom";

import Authentication from './authentication.jsx';
import LayoutAuth from '../auth/layout.jsx';
import { authService } from '../../services/auth';


const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return (
    React.createElement(component, finalProps)
  );
}

// Route component that takes properties
const PropsRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={routeProps => {
      if (!rest.authRequired && !rest.passAuthProps){
        // simple, just render the route with the props passed in
        return renderMergedProps(component, routeProps, rest);
      } else {
        // wrap in Auth component to see current user, pass returned Auth props into the component
        const redirectUrl = `${routeProps.location.pathname}${routeProps.location.search || ''}` // location to redirect to if user is not logged in
        return (
          <Authentication>
            {
              (authProps) => (  // authenticated, accessToken, refreshToken, currentUser, refreshingToken
                <React.Fragment>
                  {rest.authRequired && !authProps.authenticated && !authProps.refreshingToken ? (
                    <Redirect to={`/login/?next=${redirectUrl}`} />
                  ) : rest.authRequired && !authProps.authenticated && authProps.refreshingToken ? (
                    <div className="text-white p-4">
                      Refreshing token...{/* Refreshing token... */}
                      <br/><span className="underline" onClick={authService.logout}>Log out</span>
                    </div>
                  ) : rest.authRequired && !authProps.currentUser ? (
                    <div className="text-white p-4">
                      Fetching user...{/* Fetching user... */}
                      <br/><span className="underline" onClick={authService.logout}>Log out</span>
                    </div>
                  ) : rest.activeAccountRequired && authProps.currentUser && !authProps.currentUser.subscription && !authProps.currentUser.trial.active && !redirectUrl.includes('/trial-over/') ? (
                    <Redirect to={`/trial-over/?from=${redirectUrl}`} />
                  ) : rest.subscriptionRequired && authProps.currentUser && !authProps.currentUser.features.account_has_product_access ? (
                    <LayoutAuth title="GummySearch is now closed" subtitle="" hideFooter={true}>
                      GummySearch is now closed for business as of 11/30/2025.
                      Read more about this change <a href="https://gummysearch.com/closing-time/?utm_source=account-page" className="underline cursor-pointer">here</a>.

                      <br /><br />
                      Thank you for your support over the years. It's been a pleasure to serve you.
                      <br /><br />
                      If you're looking for similar tools, check out our <a href="https://gummysearch.com/gummysearch-alternatives/?utm_source=account-page" className="underline cursor-pointer">alternatives page</a>.
                      <br />
                      <br />
                      If you'd like to manage your account, you can do that in your <Link to="/account/" className="underline cursor-pointer">account settings</Link>,
                      or log out <span className="underline cursor-pointer" onClick={authService.logout}>here</span>.
                    </LayoutAuth>
                  ) : (
                    <React.Fragment>
                      { renderMergedProps(component, routeProps, Object.assign(rest, authProps)) }
                    </React.Fragment>
                  )}
                </React.Fragment>
              )
            }
          </Authentication>
        )
      }
    }}/>
  );
}

export default PropsRoute;